import { DELETE_ENTERPRISES_START } from '../../types';

export const delete_enterprises = (payload) => ({
  type: DELETE_ENTERPRISES_START,
  payload,
});
